import { render, staticRenderFns } from "./HistoricoContratosPublicos.vue?vue&type=template&id=69257aa2&"
import script from "./HistoricoContratosPublicos.vue?vue&type=script&lang=js&"
export * from "./HistoricoContratosPublicos.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoContratosPublicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout,VRangeSlider,VSpacer})
